export const DEFAULT_LUX_THRESHOLD = 600;
export const DEFAULT_HYSTERESIS = 10;
export const DEFAULT_ACTION_INTERVAL = 5;
